import React, { useState } from "react";
import AdminContacts from "./AdminContacts";
import Portfolioform from "./Portfolioform";
import { useNavigate } from "react-router-dom";
import "./adminDashboard.css";

export default function AdminDashboard() {
  const [activeTab, setActiveTab] = useState("portfolio");
  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.removeItem("adminAuth");
    navigate("/lifetimeMyAdmin/");
  };

  return (
    <div className="admin-dashboard">
      <div className="admin-header">
        <h1>Lifetime Infotech Admin Panel</h1>
        <button onClick={handleLogout} className="logout-btn">
          Logout
        </button>
      </div>

      <div className="admin-tabs">
        <button
          className={activeTab === "contacts" ? "active" : ""}
          onClick={() => setActiveTab("contacts")}
        >
          Contact Messages
        </button>

        <button
          className={activeTab === "portfolio" ? "active" : ""}
          onClick={() => setActiveTab("portfolio")}
        >
          Portfolio Management
        </button>
      </div>

      <div className="admin-content">
        {activeTab === "contacts" && <AdminContacts />}
        {activeTab === "portfolio" && <Portfolioform />}
      </div>
    </div>
  );
}
